import React from 'react';
import { steps } from '../../data/site';
import { SectionHeading } from '../ui/SectionHeading';
export function Steps() {
  return <section className="bg-cream-light" data-id="element-100" data-mp="1334zpxsa979h">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-101" data-mp="pa5mk2fz3p53">
        <SectionHeading eyebrow="How care works" title="Four steps, and you see the price before step three." intro="Republic is built so nothing ships and nothing is charged until a clinician has read your labs and you have approved the protocol in writing." data-id="element-102" data-mp="pc03l5o4ix3w" />

        <ol className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-0 lg:divide-x lg:divide-ink/10" data-id="element-103" data-mp="1lybvh1jxh3p6">
          {steps.map((step, index) => <li key={step.label} className="lg:px-8 lg:first:pl-0 lg:last:pr-0" data-id="element-104" data-mp="1cyyjo28c031a" data-mpi={index}>
              <div className="flex items-baseline justify-between" data-id="element-105" data-mp="3sr5p6nr3v7lg">
                <span className="font-serif text-3xl text-brick" data-id="element-106" data-mp="3ssysbt2if9op">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-107" data-mp="30np53eqot03w">
                  {step.duration}
                </span>
              </div>
              <div className="rule mt-4 pt-5" data-id="element-108" data-mp="3amodqxbgcvqw">
                <h3 className="font-serif text-2xl leading-snug text-ink" data-id="element-109" data-mp="3anfzzhj5th4i">{step.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-110" data-mp="35mjux0n2noxi">{step.detail}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}